document.addEventListener('DOMContentLoaded', function () {
  var banner = document.getElementById('homepage-banner');
  if (!banner) return;

  var targetUrl = banner.dataset.url || '/all-products';
  var transition = banner.dataset.transition || 'dissolve';
  var animating = false;

  banner.addEventListener('click', function () {
    if (animating) return;
    if (window.Shopify && window.Shopify.designMode) return;
    animating = true;

    sessionStorage.setItem('qo-door-transition', '1');
    sessionStorage.setItem('qo-show-early-access-popup', '1');

    if (transition === 'door') {
      playDoorTransition();
    } else if (transition === 'zoom') {
      playSimpleTransition('banner-zoom', 800);
    } else {
      playSimpleTransition('banner-dissolve', 800);
    }
  });

  function playDoorTransition() {
    var bannerHTML = banner.innerHTML;

    var doorLeft = document.createElement('div');
    doorLeft.className = 'homepage-banner__door homepage-banner__door--left';
    var leftContent = document.createElement('div');
    leftContent.className = 'homepage-banner__door-content';
    leftContent.innerHTML = bannerHTML;
    doorLeft.appendChild(leftContent);

    var doorRight = document.createElement('div');
    doorRight.className = 'homepage-banner__door homepage-banner__door--right';
    var rightContent = document.createElement('div');
    rightContent.className = 'homepage-banner__door-content';
    rightContent.innerHTML = bannerHTML;
    doorRight.appendChild(rightContent);

    banner.style.visibility = 'hidden';

    document.body.appendChild(doorLeft);
    document.body.appendChild(doorRight);

    requestAnimationFrame(function () {
      doorLeft.classList.add('door-animate-left');
      doorRight.classList.add('door-animate-right');
    });

    setTimeout(function () {
      window.location.href = targetUrl;
    }, 700);
  }

  function playSimpleTransition(animClass, delay) {
    requestAnimationFrame(function () {
      banner.classList.add(animClass);
    });

    setTimeout(function () {
      window.location.href = targetUrl;
    }, delay);
  }
});
